import { API_ORIGIN as BASE_URL } from "../utils/Environment";

export async function logout(logoutToken, accessToken) {
  try {
    const csrfToken = await fetch(`${BASE_URL}/session/token`);
    const csrfTokenData = await csrfToken.json();
    const csrfTokenValue = csrfTokenData._csrfToken;

    const response = await fetch(
      `${BASE_URL}/user/logout?_format=json&token=${logoutToken}`,
      {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfTokenValue,
          "Content-type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error(response.message || "Could not logout.");
    }
    return response;
  } catch (error) {
    // Handle error
  }
}

export async function login(credential) {
  const response = await fetch(`${BASE_URL}/user/login?_format=json`, {
    method: 'POST',
    body: JSON.stringify(credential),
  });
  return response;
}

export async function register(formData) {
  const response = await fetch(`${BASE_URL}/user/registerpass?_format=json`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    body: JSON.stringify(formData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(response.message || 'Could not create quote.');
  }
  return data;
}

export async function updateContactQuery(formData) {
  const response = await fetch(`${BASE_URL}/entity/contact_message`, {
    method: "POST",
    headers: {
      Authorization: `Bearer /entity/contact_message`,
      "Content-type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  return response;
}

export async function getSpeciality(profession_id) {
  const response = await fetch(`${BASE_URL}/jsonapi/attribute/speciality/${profession_id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch specialty list.');
  }
  return data;
}

export async function getCountry() {
  const response = await fetch(`${BASE_URL}/admin/city-state-city/api/get-country`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch country list.');
  }
  return data;
}

export async function getProfessional() {
  const response = await fetch(`${BASE_URL}/jsonapi/attribute/profession`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch professional list.');
  }
  return data;
}

export async function updateUserProfile(accessToken, uid, updateData) {
  const response = await fetch(`${BASE_URL}/user/${uid}?_format=json`, {
    method: 'PATCH',
    body: JSON.stringify(updateData),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Could not update details.');
  }
  return data;
}

export async function getUserProfile(accessToken, uid) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/user/profile/?filter[uid]=${uid}&include=roles,profession,specialty&jsonapi_include=1`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-type': 'application/json',
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch profile details.');
  }
  return data;
}

export async function getAllResourceList() {
  const response = await fetch(`${BASE_URL}/jsonapi/attribute/profession`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch resources list.');
  }
  return data;
}

export async function getFavouriteList() {
  const response = await fetch(`${BASE_URL}/jsonapi/need-help`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Could not fetch favourite list.');
  }
  return data;
}

export async function getBannerDetails(currentUser) {
  if (currentUser === null) {
    const response = await fetch(
      `${BASE_URL}/viewapi/banner-list`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Could not fetch banner details.");
    }
    return data;
  } else {
    const response = await fetch(
      `${BASE_URL}/viewapi/protected/banner-list`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${currentUser.access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Could not fetch banner details.");
    }
    return data;
  }
}

export async function getPages() {
  const response = await fetch(
    `${BASE_URL}/jsonapi/basiclandingpages?_format=json`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch footer pages.");
  }
  return data;
}

export async function getMidBanner() {
  const response = await fetch(`${BASE_URL}/uiapi/mid-banner`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch quotes.");
  }
  return data;
}

export async function getQuickLinks() {
  const response = await fetch(`${BASE_URL}/jsonapi/resource/cards`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch quotes.");
  }
  return data;
}

export async function getPagesData(slug_url) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/basiclandingpages/detail?alias=/${slug_url}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch footer page data.");
  }
  return data;
}

export async function getResourceSearch() {
  const response = await fetch(`${BASE_URL}/uiapi/tags`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch search keywords.");
  }
  return data;
}

export async function validateEmail(email) {
  const response = await fetch(`${BASE_URL}/jsonapi/user/email/${email}?_format=json`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch valid emails.");
  }
  return data;
}

export async function getSliderDetails() {
  const response = await fetch(`https://dev-backstage.mastersvideolibrary.com/jsonapi/videos`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch details.");
  }
  return data;
}

export async function getSupportCategory(currentUser) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/attribute/support/category`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch support category.");
  }
  return data;
}

export async function getSupportSubCategory(currentUser, tid) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/attribute/support/subcategory/${tid}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch support sub category.");
  }
  return data;
}

export async function getUserActivation(userId, userToken) {
  const response = await fetch(`${BASE_URL}/api/user/registration/confirm/${userId}/${userToken}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Could not fetch quotes.");
  }
  return data;
}

export async function getRelatedIssueList(currentUser) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/attribute/support/issues`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch related issues list.");
  }
  return data;
}

export async function getAppList(currentUser) {
  const response = currentUser ? await fetch(
    `${BASE_URL}/jsonapi/protected/resource`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  ) : await fetch(
    `${BASE_URL}/jsonapi/resource`,
    {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch application list.");
  }
  return data;
}

export async function getAppDetail(currentUser, slugUrl) {
  const response = currentUser ? await fetch(
    `${BASE_URL}/jsonapi/protected/resource/detail?alias=/${slugUrl}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  ) : await fetch(
    `${BASE_URL}/jsonapi/resource/detail?alias=/${slugUrl}`,
    {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch application list.");
  }
  return data;
}

export async function getRelatedAppList(tid) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/resource/related/tags/${tid}`,
    {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch related application list.");
  }
  return data;
}

export async function getRelatedResourceList(tid) {
  const response = await fetch(
    `${BASE_URL}/jsonapi/resource/related/${tid}`,
    {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch related application list.");
  }
  return data;
}

export async function getSubscribedAppList(currentUser) {
  const response = await fetch(
    `${BASE_URL}/uiapi/myresource/${currentUser.current_user.uid}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch subscribed application list.");
  }
  return data;
}

export async function updateSubscribedAppList(currentUser, updatedData) {
  const response = await fetch(`${BASE_URL}/api/myresource`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
      body: JSON.stringify(updatedData),
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not update subcribed application list.");
  }
  return data;
}

export async function removeSubscribedAppList(currentUser, nid) {
  const response = await fetch(`${BASE_URL}/api/myresource/${nid}/${currentUser.current_user.uid}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      }
    }
  )
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not update subcribed application list.");
  }
  return data;
}

export async function updateNotificationRead(currentUser, formData) {
  const response = await fetch(`${BASE_URL}/jsonapi/flagging/contact_message_read_status`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${currentUser.access_token}`,
      "Content-type": "application/vnd.api+json",
    },
    body: JSON.stringify(formData),
  });
  return response;
}

export async function getNotification(currentUser, notificationId) {
  let id = notificationId ? `/${notificationId}` : "";
  const response = await fetch(
    `${BASE_URL}/jsonapi/message/notification${id}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentUser.access_token}`,
        "Content-type": "application/json",
      },
    }
  );
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch notification.");
  }
  return data;
}

export async function emailPasswordLinkSend(emailData) {
  const response = await fetch(`${BASE_URL}/user/lost-password?_format=json`, {
    method: "POST",
    body: JSON.stringify(emailData),
    headers: {
      "Content-type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not sent forgot password link.");
  }
  return data;
}

export async function resetPasswordUpdate(passwordData) {
  const response = await fetch(`${BASE_URL}/user/lost-password-reset?_format=json`, {
    method: "POST",
    body: JSON.stringify(passwordData),
    headers: {
      "Content-type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not update password data.");
  }
  return data;
}
